// Emailed links carry their bearer token in the URL fragment (#name=value), which the
// browser never sends, so it stays out of request lines and router logs. The page reads
// it here and sends it only in a request body (see FragmentTokenLink on the server).

function historyState(): Record<string, unknown> {
  const { state } = window.history;

  return typeof state === 'object' && state !== null ? state : {};
}

function stashedToken(name: string): string | null {
  const stashed = historyState()[name];

  return typeof stashed === 'string' && stashed ? stashed : null;
}

// Returns the token and strips it from the address bar, so it does not linger in
// document.location. It moves to the history entry's state, which no request carries,
// so a reload or a restored tab still finds it.
function takeFragmentToken(name: string): string | null {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const token = params.get(name);
  if (token === null) return stashedToken(name);

  params.delete(name);
  const rest = params.toString();
  const { pathname, search } = window.location;
  const url = `${pathname}${search}${rest ? `#${rest}` : ''}`;
  window.history.replaceState({ ...historyState(), [name]: token }, '', url);

  return token || null;
}

// Fills each `input[data-fragment-token="<name>"]` with that fragment token and submits
// the forms marked `data-fragment-token-submit`, which only carry the token onwards.
function fillFragmentTokenInputs(root: ParentNode = document) {
  root.querySelectorAll<HTMLInputElement>('input[data-fragment-token]').forEach(input => {
    const token = takeFragmentToken(input.dataset.fragmentToken ?? '');
    if (!token) return;

    input.value = token;
    if (input.form?.hasAttribute('data-fragment-token-submit')) input.form.submit();
  });
}

export { takeFragmentToken, fillFragmentTokenInputs };
